import React, {Fragment, useCallback, useEffect, useState} from 'react';
import {GUTTER_SM, MARGIN_MD} from "../../../styles/constants";
import EnhancedModal from '../../../components/enhanced-modal';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {
  changeHierarchicalCodelistsHierarchicalCodelistDetail,
  hideHierarchicalCodelistsHierarchicalCodelistDetail,
  readHierarchicalCodelistsAgencies,
  readHierarchicalCodelistsHierarchicalCodelistDetail,
  showHierarchicalCodelistsHierarchicalCodelistClone,
  showHierarchicalCodelistsHierarchicalCodelistDownload,
  showHierarchicalCodelistsHierarchicalCodelistExport,
  submitHierarchicalCodelistsHierarchicalCodelistCreate,
  submitHierarchicalCodelistsHierarchicalCodelistSave,
  submitHierarchicalCodelistsHierarchicalCodelistUpdate
} from "./actions";
import {Alert, Button, Col, Modal, Row, Switch, Tabs} from "antd";
import ArtefactForm, {
  ARTEFACT_FORM_MODE_CREATE,
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import {isArtefactValid, isHierarchicalCodelistDefinitionValid} from "../../../utils/artefactValidators";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import HierarchicalCodelistDetailItems from "./Items";
import { hierarchicalCodelistHasLevelBasedHierarchies } from './utils';

const mapStateToProps = state => ({
  permissions: state.app.user.permissions,
  appLanguage: state.app.language,
  isVisible: state.scenes.metaManager.hierarchicalCodelists.isDetailVisible,
  hierarchicalCodelistTriplet: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelistTriplet,
  hierarchicalCodelist: state.scenes.metaManager.hierarchicalCodelists.hierarchicalCodelist,
  agencies: state.scenes.metaManager.hierarchicalCodelists.agencies,
  focusItemsTab: state.scenes.metaManager.hierarchicalCodelists.focusItemsTab,
  isHierarchicalCodelistGeneralTabDirty: state.scenes.metaManager.hierarchicalCodelists.isHierarchicalCodelistGeneralTabDirty,
  unsavedChange: state.scenes.metaManager.hierarchicalCodelists.unsavedChange,
});

const mapDispatchToProps = dispatch => ({
  onHierarchicalCodelistDetailHide: () => dispatch(hideHierarchicalCodelistsHierarchicalCodelistDetail()),
  onHierarchicalCodelistDetailChange: fields => 
    dispatch(changeHierarchicalCodelistsHierarchicalCodelistDetail(fields)),
  onHierarchicalCodelistDetailCreate: (hierarchicalCodelist, hierarchicalCodelistTriplet) => 
    dispatch(submitHierarchicalCodelistsHierarchicalCodelistCreate(hierarchicalCodelist, hierarchicalCodelistTriplet)),
  onHierarchicalCodelistDetailUpdate: ( hierarchicalCodelist) => 
    dispatch(submitHierarchicalCodelistsHierarchicalCodelistUpdate( hierarchicalCodelist)),
  fetchHierarchicalCodelist: hierarchicalCodelistTriplet => 
    dispatch(readHierarchicalCodelistsHierarchicalCodelistDetail(hierarchicalCodelistTriplet)),
  fetchAgencies: allowedAgencies => dispatch(readHierarchicalCodelistsAgencies(allowedAgencies)),
  onCloneShow: artefactTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showHierarchicalCodelistsHierarchicalCodelistExport(sourceTriplet)),
  onDownloadShow: (hierarchicalCodelistTriplets, lang) => 
    dispatch(showHierarchicalCodelistsHierarchicalCodelistDownload(hierarchicalCodelistTriplets, lang)),
  onHierarchicalCodelistAutoSave: (hierarchicalCodelist) => dispatch(submitHierarchicalCodelistsHierarchicalCodelistSave(hierarchicalCodelist))
});

const HierarchicalCodelistDetail = ({
                                      t,
                                      appLanguage,
                                      permissions,
                                      isVisible,
                                      hierarchicalCodelistTriplet,
                                      hierarchicalCodelist,
                                      agencies,
                                      focusItemsTab,
                                      isHierarchicalCodelistGeneralTabDirty,
                                      unsavedChange,
                                      onHierarchicalCodelistDetailHide,
                                      onHierarchicalCodelistDetailChange,
                                      onHierarchicalCodelistDetailCreate,
                                      onHierarchicalCodelistDetailUpdate,
                                      onHierarchicalCodelistAutoSave,
                                      fetchHierarchicalCodelist,
                                      fetchAgencies,
                                      onDownloadShow,
                                      onCloneShow,
                                      onExportShow
                                    }) => {

  const userHasPermissionsOnAgency = (
    permissions && hierarchicalCodelistTriplet &&
    permissions.agencies.filter(agency => agency === hierarchicalCodelistTriplet.agencyID).length > 0
  );

  const [currentTab, setCurrentTab] = useState("general");  
  const [autoSave, setAutoSave] = useState(true);

  useEffect(() => {
    if (isVisible ) {
      if (focusItemsTab) 
      {
        setCurrentTab("items");
      } 
      else 
      {
        setCurrentTab("general");
      }
    }
    return () => setCurrentTab("general");
  }, [focusItemsTab, isVisible]);

  const hideHierarchicalCodelistDetail = useCallback(() => {
    if (isHierarchicalCodelistGeneralTabDirty || unsavedChange) {
      Modal.confirm({
        title: t('commons.artefact.modals.unsavedChange.discard.title'),
        onOk() {
          onHierarchicalCodelistDetailHide();
        },
        cancelText: t('commons.buttons.cancel.title')
      })
    } else {
      onHierarchicalCodelistDetailHide();
    }
  }, [isHierarchicalCodelistGeneralTabDirty, unsavedChange]);

  const onHierarchicalCodelistSave = useCallback(() => {
    if (!isArtefactValid(hierarchicalCodelist)) {
      Modal.warning({
        title: t('commons.alerts.invalidForm.title'),
        content: t('commons.alerts.invalidForm.content')
      });
    } 
    else if (hierarchicalCodelistTriplet === null) {
      onHierarchicalCodelistDetailCreate(hierarchicalCodelist,
        {
        id: hierarchicalCodelist.id,
        agencyID: hierarchicalCodelist.agencyID,
        version: hierarchicalCodelist.version
        });
    }
    else if (isHierarchicalCodelistDefinitionValid(hierarchicalCodelist)) {
        onHierarchicalCodelistDetailUpdate(hierarchicalCodelist);
  }
    else {
      Modal.warning({
        title: t('components.hierarchicalCodelistDetailItems.badDefinition.title'),
        content: t('components.hierarchicalCodelistDetailItems.badDefinition.hierarchyEmpty.msg')
      });
    } 
    }, [hierarchicalCodelistTriplet, hierarchicalCodelist])  

  return (
    <Call 
      cb={fetchHierarchicalCodelist} 
      cbParam={hierarchicalCodelistTriplet}
      disabled={hierarchicalCodelistTriplet === null } 
    >
      <Call 
        cb={fetchAgencies} 
        cbParam={permissions ? permissions.agencies : undefined}
      >
        <EnhancedModal
          visible={isVisible}
          fullscreen
          title={
            hierarchicalCodelistTriplet !== null
              ? ((userHasPermissionsOnAgency)
                ? t('scenes.metaManager.hierarchicalCodelists.detail.title.editMode.title', {triplet: hierarchicalCodelistTriplet})
                : t('scenes.metaManager.hierarchicalCodelists.detail.title.viewMode.title', {triplet: hierarchicalCodelistTriplet})
              )
              : t('scenes.metaManager.hierarchicalCodelists.detail.title.createMode.title')
          }          
          onCancel={hideHierarchicalCodelistDetail}
          footer={
            <div className="hcl__items__footer">
              <Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                {(hierarchicalCodelistTriplet !== null || userHasPermissionsOnAgency)
                  ? (
                    <Col>
                      <Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                        <Col>
                          {t("components.itemList.label.autoSave")}
                        </Col>
                        <Col>
                          <Switch
                            checked={autoSave}
                            onChange={() => setAutoSave(!autoSave)}
                            disabled={hierarchicalCodelist && hierarchicalCodelist.isFinal}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )
                  : null}
                  <Col>
              <Button
                onClick={hideHierarchicalCodelistDetail}
              >
                  {t('commons.buttons.close.title')}
              </Button>
                  </Col>
              {(hierarchicalCodelistTriplet === null || userHasPermissionsOnAgency)
                ? (
                  <Col>
                  <Button
                    type="primary"
                      onClick={() => onHierarchicalCodelistSave(hierarchicalCodelist)}
                  >
                    {t("commons.buttons.save.title")}
                  </Button>
                  </Col>                  
                )
                : null}
              </Row>              
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const lang = dataLanguage || appLanguage;
              return hierarchicalCodelistTriplet
              ? (
                  <Fragment>
                    {permissions && !userHasPermissionsOnAgency && (
                      <Alert
                        type="warning"
                        showIcon
                        message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                      />
                    )}
                    <Row type="flex" gutter={GUTTER_SM} justify={"end"}
                        style={{marginBottom: MARGIN_MD}}>
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="download"
                          size="small"
                          title={t('commons.artefact.buttons.download.title')}
                          onClick={() => onDownloadShow([hierarchicalCodelistTriplet], lang)}
                        />
                      </Col>
                      {permissions && (
                        <Col>
                          <Button
                            type="primary"
                            shape="circle"
                            icon="copy"
                            size="small"
                            title={t('commons.artefact.buttons.clone.title')}
                            onClick={() => onCloneShow(hierarchicalCodelistTriplet)}
                          />
                        </Col>
                      )}
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="export"
                          size="small"
                          title={t('commons.artefact.buttons.export.title')}
                          onClick={() => onExportShow(hierarchicalCodelistTriplet)}
                        />
                      </Col>
                    </Row>
                    <Tabs
                      className="hcl__detail__tab"
                      activeKey={currentTab}
                      onTabClick={
                        key => {
                          if (!isArtefactValid(hierarchicalCodelist)) {
                            Modal.warning({
                              title: t('commons.alerts.invalidForm.title'),
                              content: t('commons.alerts.invalidForm.content')
                            });
                          }
                          else if (key === "items" && hierarchicalCodelistHasLevelBasedHierarchies(hierarchicalCodelist)) {
                            Modal.error({
                              title: t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.title'),
                              content: t('components.hierarchicalCodelistDetailItems.hierarchyForm.notSupported.content')
                            });
                            setCurrentTab("general");
                          }
                          else {
                            setCurrentTab(key);                        
                            if (isHierarchicalCodelistGeneralTabDirty) {
                              onHierarchicalCodelistDetailUpdate(hierarchicalCodelist);
                            }
                          }
                        }
                      }
                    >
                      <Tabs.TabPane
                        key="general"
                        tab={t('commons.artefact.tabs.general.title')}
                      >
                        <ArtefactForm
                          artefact={hierarchicalCodelist}
                          mode={userHasPermissionsOnAgency ? ARTEFACT_FORM_MODE_EDIT : ARTEFACT_FORM_MODE_READ}
                          agencies={agencies}
                          onChange={onHierarchicalCodelistDetailChange}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        key="items"
                        tab={t('commons.artefact.tabs.items.title')}
                      >
                        <HierarchicalCodelistDetailItems
                          disabled={!userHasPermissionsOnAgency || (hierarchicalCodelist && hierarchicalCodelist.isFinal)}
                          autoSave={autoSave}
                          onHierarchicalCodelistSave={onHierarchicalCodelistAutoSave}
                        />
                      </Tabs.TabPane>
                    </Tabs>
                  </Fragment>
                  )
                  : (
                    <ArtefactForm
                      artefact={hierarchicalCodelist}
                      mode={ARTEFACT_FORM_MODE_CREATE}
                      agencies={agencies}
                      onChange={onHierarchicalCodelistDetailChange}
                    />
                  )
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(HierarchicalCodelistDetail);
